import Natural from "./Natural"


class PlayerNatural extends Natural {

}

export default PlayerNatural
